import React from 'react';
import { Card } from '../ui/Card';
import { CalendarIcon, ClockIcon, PlusIcon } from 'lucide-react';
export function BookingsTab({
  contact
}) {
  const formatDate = dateString => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    }).format(date);
  };
  const formatTime = dateString => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit'
    }).format(date);
  };
  return <div data-id="element-228">
      <div className="flex justify-between items-center mb-4" data-id="element-229">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-230">Upcoming Bookings</h2>
        <button className="flex items-center gap-1 px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm" data-id="element-231">
          <PlusIcon className="w-4 h-4" data-id="element-232" />
          <span data-id="element-233">New Booking</span>
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-234">
        {contact.bookings.map(booking => <Card key={booking.id} title={booking.title} data-id="element-235">
            <div className="flex flex-col gap-2" data-id="element-236">
              <div className="flex items-center gap-2 text-gray-600" data-id="element-237">
                <CalendarIcon className="w-4 h-4 text-gray-400" data-id="element-238" />
                <span data-id="element-239">{formatDate(booking.date)}</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-240">
                <ClockIcon className="w-4 h-4 text-gray-400" data-id="element-241" />
                <span data-id="element-242">{booking.duration}</span>
              </div>
              <div className="mt-2 flex gap-2" data-id="element-243">
                <button className="px-3 py-1.5 bg-white border border-gray-300 text-gray-700 rounded hover:bg-gray-50 text-sm" data-id="element-244">
                  Reschedule
                </button>
                <button className="px-3 py-1.5 bg-white border border-gray-300 text-gray-700 rounded hover:bg-gray-50 text-sm" data-id="element-245">
                  Cancel
                </button>
              </div>
            </div>
          </Card>)}
        {contact.bookings.length === 0 && <div className="col-span-2 text-center py-8 bg-gray-50 rounded-lg border border-dashed border-gray-300" data-id="element-246">
            <CalendarIcon className="w-10 h-10 text-gray-400 mx-auto mb-2" data-id="element-247" />
            <h3 className="text-gray-500 font-medium" data-id="element-248">No bookings scheduled</h3>
            <p className="text-gray-400 text-sm mt-1" data-id="element-249">
              Schedule a meeting with this contact
            </p>
            <button className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm" data-id="element-250">
              Create Booking
            </button>
          </div>}
      </div>
    </div>;
}